import { SystemPostPresignedUrlPayload } from 'models/swagger/data-contracts';

const NUMBER_REGEX = /[^0-9]/g;
const EMAIL_REGEX = /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
const COMPANY_REGISTRATION_NUMBER = /^[0-9]{3}-[0-9]{2}-[0-9]{5}$/;
const WHITE_SPACE_REGEX = /\s/g;

// 숫자만 추출하여 return
export const returnOnlyNumber = (value: string | undefined) => {
  if (!value) return 0;

  return Number(value.replace(NUMBER_REGEX, ''));
};

// 숫자만 추출하여 string 형식으로 return
export const returnOnlyNumber_toString = (value: string) => {
  if (!value) return '0';

  return value.replace(NUMBER_REGEX, '');
};

// 이메일 유효성 검사
export const isValidateEmail = (value: string) => {
  return EMAIL_REGEX.test(value);
};

// 비밀번호 유효성 검사
export const isValidatePassword = (value: string) => {
  return PASSWORD_REGEX.test(value);
};

// 사업자 등록 번호 유효성 검사
export const isValidateCompanyRegistrationNumber = (value: string) => {
  return COMPANY_REGISTRATION_NUMBER.test(value);
};

// 파일 확장자 return
export const returnFileExtension = (filename: string): SystemPostPresignedUrlPayload['ext'] => {
  const ext = filename.split('.').pop();

  if (
    ext === 'jpg' ||
    ext === 'jpeg' ||
    ext === 'png' ||
    ext === 'csv' ||
    ext === 'xls' ||
    ext === 'xlsx' ||
    ext === 'zip' ||
    ext === 'pdf'
  ) {
    return ext;
  }
};

// number를 (,)형 string으로 return
export const returnNumberWithComma = (value: number): string => {
  if (!value) return '0';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// 공백제거 return
export const returnRemoveWhiteSpace = (value: string): string => {
  return value.replace(WHITE_SPACE_REGEX, '');
};
